// extracted by css-extract-rspack-plugin
export default {"cls1":"AddToListButton-cls1_YS7","cls2":"AddToListButton-cls2_1nq AddToListButton-cls1_YS7"};